import {
  DeleteOutlineIcon,
  MinusOutlineIcon,
  MoreVerticalOutlineIcon,
  PlusOutlineIcon,
} from '@carboncopyco/icons';
import {
  Button,
  Dropdown as DropdownComponent,
  DropdownItem,
} from '@carboncopyco/ui';

interface IDropdown {
  onDropdownButtonClick: () => void;
  onAddStepAboveClick: () => void;
  onAddStepBellowClick: () => void;
  onDeleteClick: () => void;
}

const Dropdown = ({
  onDropdownButtonClick,
  onAddStepAboveClick,
  onAddStepBellowClick,
  onDeleteClick,
}: IDropdown) => {
  return (
    <DropdownComponent
      asChild
      triggerElement={
        <div
          className="hover:opacity-100 group-hover:visible invisible"
          data-testid="step-context-menu-button"
        >
          <Button
            dark
            icon={<MoreVerticalOutlineIcon />}
            onClick={onDropdownButtonClick}
          />
        </div>
      }
    >
      <div data-testid="step-context-menu-add-step-above">
        <DropdownItem
          label="Add step above"
          onClick={onAddStepAboveClick}
          iconLeft={<PlusOutlineIcon size={24} />}
        />
      </div>
      <div data-testid="step-context-menu-add-step-below">
        <DropdownItem
          label="Add step below"
          onClick={onAddStepBellowClick}
          iconLeft={<MinusOutlineIcon size={24} />}
        />
      </div>
      <div data-testid="step-context-menu-delete-step">
        <DropdownItem
          label="Delete step"
          onClick={onDeleteClick}
          iconLeft={<DeleteOutlineIcon size={24} />}
        />
      </div>
    </DropdownComponent>
  );
};

export default Dropdown;
